import { useQuery } from '@apollo/client';
import { Typography } from '@mui/material';
import { TreeList } from '@prismamedia/one-components';
import {
  GetNewslettersQuery,
  GetNewslettersQueryVariables,
} from '__generated__/queries-newsletter';
import { GET_NEWSLETTERS_QUERY } from 'apollo/queries/getNewsletters.newsletter.graphql';
import { CircularLoader } from 'components/CircularLoader';
import { FC } from 'react';
import {
  useGlobalBrandKey,
  useGlobalNewslettersFilter,
} from 'utils/globalState';
import { useStyles } from './styles';
import { getTemplatesTree } from './templatesTree';

export const FilterDrawer: FC = () => {
  const classes = useStyles();
  const [brandKey] = useGlobalBrandKey();
  const { data, error, loading } = useQuery<
    GetNewslettersQuery,
    GetNewslettersQueryVariables
  >(GET_NEWSLETTERS_QUERY, {
    variables: { first: 1000, where: { brandKey } },
  });
  const [
    newslettersFilter,
    setNewslettersFilter,
  ] = useGlobalNewslettersFilter();

  if (loading) {
    return (
      <div className={classes.centered}>
        <CircularLoader size={50} />
      </div>
    );
  }

  if (!data || error) {
    return (
      <div className={classes.centered}>
        <Typography>Une erreur s'est produite</Typography>
      </div>
    );
  }

  return (
    <TreeList
      nodes={getTemplatesTree(data.newsletters)}
      checkedIds={newslettersFilter}
      setCheckedIds={setNewslettersFilter}
    />
  );
};
